import $ from 'jquery';

    $(document).ready(function() {
        let previousTarget = null;
        $(".tab").on('click mouseenter', function(e) {
            if (this === previousTarget) {
                return false;
            }
            previousTarget = this;
            const target = $(this).attr("data-tab-target").replace('#', '');
            const tabContent = $(".tab-content").find('#' + target);
            $(".tab-content > div").removeClass("active");
            $(".tab").removeClass("active");
            $(this).addClass("active");
            $(tabContent).addClass("active");
        });
        const tabPillarContent = $(".tab-pillar-content").height();
        $(".tab-list-services").css({
            height: tabPillarContent
        });
    });
